import { render, staticRenderFns } from "./evidence-collection-view.vue?vue&type=template&id=32e546b2&"
import script from "./evidence-collection-view.vue?vue&type=script&lang=js&"
export * from "./evidence-collection-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports